<ng-container *ngIf="merchant">
    <!-- Tab Navigation -->
    <div class="settings-nav">
        <a class="settings-nav__item"
           [class.settings-nav__item--active]="tab === 'details'"
           [routerLink]="['/merchant', merchant.$key, 'profile', 'details']">
            <i class="fa-solid fa-building"></i>
            <span>Details</span>
        </a>
        <a class="settings-nav__item"
           [class.settings-nav__item--active]="tab === 'managers'"
           [routerLink]="['/merchant', merchant.$key, 'profile', 'managers']">
            <i class="fa-solid fa-users"></i>
            <span>Managers</span>
        </a>
        <a class="settings-nav__item"
           [class.settings-nav__item--active]="tab === 'security'"
           [routerLink]="['/merchant', merchant.$key, 'profile', 'security']">
            <i class="fa-solid fa-shield-halved"></i>
            <span>Onsite Personnel</span>
        </a>
        <a *ngIf="!merchant.bookuppEnabled"
           class="settings-nav__item"
           [class.settings-nav__item--active]="tab === 'payout'"
           [routerLink]="['/merchant', merchant.$key, 'profile', 'payout']">
            <i class="fa-solid fa-wallet"></i>
            <span>Payout Details</span>
        </a>
        <a *ngIf="merchant.bookuppEnabled"
           class="settings-nav__item"
           [class.settings-nav__item--active]="tab === 'branding'"
           [routerLink]="['/merchant', merchant.$key, 'profile', 'branding']">
            <i class="fa-solid fa-palette"></i>
            <span>Branding</span>
        </a>
        <a class="settings-nav__item"
           [class.settings-nav__item--active]="tab === 'audit'"
           [routerLink]="['/merchant', merchant.$key, 'profile', 'audit']">
            <i class="fa-solid fa-clipboard-list"></i>
            <span>Audit</span>
        </a>
    </div>

    <!-- Tab Content -->
    <div class="settings-content">
        <!-- Details Tab -->
        <div *ngIf="tab === 'details'" class="settings-panel">
            <div class="settings-card">
                <div class="settings-card__header">
                    <div class="settings-card__icon settings-card__icon--blue">
                        <i class="fa-solid fa-building"></i>
                    </div>
                    <div>
                        <h2 class="settings-card__title">Portfolio Details</h2>
                        <p class="settings-card__description">Update your company information and contact details</p>
                    </div>
                </div>
                <div class="settings-card__body">
                    <app-merchant-profile-form [merchantKey]="merchant.$key!" [dashboardView]="dashboardView" [showHeading]="false"></app-merchant-profile-form>
                </div>
            </div>
        </div>

        <!-- Managers Tab -->
        <div *ngIf="tab === 'managers'" class="settings-panel">
            <div class="settings-card">
                <div class="settings-card__header">
                    <div class="settings-card__icon settings-card__icon--purple">
                        <i class="fa-solid fa-users"></i>
                    </div>
                    <div>
                        <h2 class="settings-card__title">Portfolio Managers</h2>
                        <p class="settings-card__description">Manage team members who have access to this portfolio</p>
                    </div>
                </div>
                <div class="settings-card__body">
                    <app-merchant-members-list [merchantKey]="merchant.$key!" [showHeading]="false"></app-merchant-members-list>
                </div>
            </div>
        </div>

        <!-- Onsite Personnel Tab -->
        <div *ngIf="tab === 'security'" class="settings-panel">
            <div class="settings-card">
                <div class="settings-card__header">
                    <div class="settings-card__icon settings-card__icon--teal">
                        <i class="fa-solid fa-shield-halved"></i>
                    </div>
                    <div>
                        <h2 class="settings-card__title">Onsite Personnel Notifications</h2>
                        <p class="settings-card__description">Configure WhatsApp notifications for parking contract changes</p>
                    </div>
                </div>
                <div class="settings-card__body">
                    <p class="security-description">
                        Add onsite personnel phone numbers below to receive WhatsApp notifications when parking contracts start or end.
                        They will be notified to arrange or revoke access accordingly. You can enter multiple phone numbers separated by commas.
                    </p>
                    <div class="security-form">
                        <label class="form-label">Onsite Personnel Phone Numbers</label>
                        <input
                            [(ngModel)]="securityPhoneNumbers"
                            class="form-input"
                            placeholder="e.g. 0821234567, 0839876543"
                            type="text"
                        />
                        <button (click)="saveSecurityPhoneNumbers()" class="btn-save" type="button">Save</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Payout Details Tab -->
        <div *ngIf="tab === 'payout' && !merchant.bookuppEnabled" class="settings-panel">
            <div class="settings-card">
                <div class="settings-card__header">
                    <div class="settings-card__icon settings-card__icon--green">
                        <i class="fa-solid fa-wallet"></i>
                    </div>
                    <div>
                        <h2 class="settings-card__title">Payout Details</h2>
                        <p class="settings-card__description">Manage your banking details for receiving payouts</p>
                    </div>
                </div>
                <div class="settings-card__body">
                    <app-merchant-banking-details-form [merchantKey]="merchant.$key!" [bankDetailsModal]="false"></app-merchant-banking-details-form>
                </div>
            </div>
        </div>

        <!-- Branding Tab -->
        <div *ngIf="tab === 'branding' && merchant.bookuppEnabled" class="settings-panel">
            <div class="settings-card">
                <div class="settings-card__header">
                    <div class="settings-card__icon settings-card__icon--purple">
                        <i class="fa-solid fa-palette"></i>
                    </div>
                    <div>
                        <h2 class="settings-card__title">Branding & White-Label</h2>
                        <p class="settings-card__description">Customise your parking portal with your own branding</p>
                    </div>
                </div>
                <div class="settings-card__body">
                    <app-merchant-branding-form [merchantKey]="merchant.$key!"></app-merchant-branding-form>
                </div>
            </div>
        </div>

        <!-- Audit Tab -->
        <div *ngIf="tab === 'audit'" class="settings-panel">
            <div class="settings-card">
                <div class="settings-card__header">
                    <div class="settings-card__icon settings-card__icon--orange">
                        <i class="fa-solid fa-clipboard-list"></i>
                    </div>
                    <div>
                        <h2 class="settings-card__title">Audit Log</h2>
                        <p class="settings-card__description">Review WhatsApp and email communication history</p>
                    </div>
                </div>
                <div class="settings-card__body">
                    <app-merchant-profile-audit [merchant]="merchant"></app-merchant-profile-audit>
                </div>
            </div>
        </div>
    </div>
</ng-container>
